import { useEffect, useRef, useState } from "react";
import {
  Card,
  Row,
  Col,
  Image,
  Divider,
  Button,
  Table,
  Spin,
  Badge,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "./Payments.css";
import { useMediaQuery } from "react-responsive";
import BackArrow from "../../../assests/back-arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import StackedDollarBag from "../../../assests/stacked-dollar-bag.svg";
import { ReactComponent as ProfitGraphIcon } from "../../../assests/profit-graph.svg";
import { useDispatch, useSelector } from "react-redux";
import { getSellerCampaignsList } from "../../../store/thunks/seller-thunks/SellerThunk";
import {
  formatToUSCurrency,
  handleCopy,
} from "../../../components/common/utils/Utils";
import EmptyViewCard from "../../../components/common/empty-view-card/EmptyViewCard";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { CopyOutlined } from "@ant-design/icons";
const Payments = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const payoutOverview = searchParams.get("payoutOverview") === "true";
  const price = useRef();
  const [headerText, setHeaderText] = useState("Your Earnings & Payouts");
  const [allCampaigns, setAllCampaigns] = useState(false);
  const payIcon = (
    <Button shape="circle" className="pay-icon">
      <Image src={StackedDollarBag} preview={false} />
    </Button>
  );
  const dispatch = useDispatch();
  const { isLoading, data } = useSelector((state) => state.sellerCampaigns);
  const formatDate = (value) => {
    const date = new Date(value);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };

  const highestPayout = (campaignsList) => {
    let campaignPriceList = campaignsList?.map(
      (campaign) => campaign?.total_price
    );
    price.maxPrice = Math.max(...campaignPriceList);
    return Math.max(...campaignPriceList);
  };

  const highestCampaign = (maxPrice, data) => {
    return (
      data?.length > 0 &&
      data?.find((campaign) => campaign?.total_price === maxPrice)?.name
    );
  };

  const getPendingPayments = (data) => {
    let pendingPrice = 0;
    data?.forEach((record) => {
      pendingPrice += record?.total_price - record?.total_paid_seller;
    });
    return pendingPrice;
  };

  const getTotalPayments = (data) => {
    let totalPaidAmount = 0;
    data?.forEach((record) => {
      totalPaidAmount += record?.total_paid_seller;
    });
    return totalPaidAmount;
  };
  const paymentCardGroup = [
    {
      title: "Total Earning",
      button: payIcon,
      cost: data?.length > 0 ? getTotalPayments(data) : 0,
      hasProfit: false,
      numberOfDays: "Last 30 days",
    },
    {
      title: "Pending Payouts",
      button: payIcon,
      cost: data?.length > 0 ? getPendingPayments(data) : 0,
      hasProfit: false,
      profitIcon: data?.length > 0 ? <ProfitGraphIcon /> : "",
      numberOfDays: "Last 30 days",
    },
    {
      title: "Last Payout Received",
      button: payIcon,
      cost: data?.length > 0 && data?.[0]?.total_paid_seller?.toFixed(2),
      hasProfit: false,
      profitIcon: <ProfitGraphIcon />,
      numberOfDays:
        data && data?.length > 0 && formatDate(data?.[0]?.updated_at),
    },
    {
      title: "Highest Payout Received",
      button: payIcon,
      cost: data && data?.length > 0 && highestPayout(data),
      hasProfit: false,
      profitIcon: <ProfitGraphIcon />,
      ad: data && data?.length > 0 && highestCampaign(price?.maxPrice, data),
    },
  ];
  const handleGoToSubPage = ({ title, path }) => {
    dispatch(
      addBreadcrumb({
        title,
        path,
      })
    );
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "updated_at",
      key: "updated_at",
      align: "left",
      render: (value) => {
        return formatDate(value);
      },
      width: 30,
    },
    {
      title: "Campaign ID",
      dataIndex: "cid",
      render: (text, record) => (
        <div className="product-copy-text-field">
          <a
            className="campaign-link"
            onClick={(e) => {
              e.preventDefault(); // Prevent full page reload
              handleGoToSubPage({
                title: record?.name,
                path: `/seller/viewCampaigns/campaignDetails/${btoa(
                  record?.id
                )}`,
              });
              navigate(
                `/seller/viewCampaigns/campaignDetails/${btoa(record?.id)}`
              );
            }}
          >
            {text}
          </a>
          <CopyOutlined
            onClick={(e) => {
              e.stopPropagation(); // prevent tooltip close
              handleCopy(text);
            }}
            className="copy-icon"
          />
        </div>
      ),
      key: "cid",
      align: "left",
      width: 50,
    },
    {
      title: "Campaign",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: 60,
      render: (text, record) => (
        <div className="product-copy-text-field">
          <span className="campaign-id ">
            {text}{" "}
            <CopyOutlined
              onClick={(e) => {
                e.stopPropagation(); // prevent tooltip close
                handleCopy(record?.name);
              }}
              className="copy-icon"
            />
          </span>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "total_price",
      key: "total_price",
      render: (value) => (
        <div style={{ textAlign: "right" }}>
          {formatToUSCurrency(value?.toFixed(2))}
        </div>
      ),
      width: 40,
      align: "right",
    },
    {
      title: "Paid",
      dataIndex: "total_paid_seller",
      key: "total_paid_seller",
      render: (value) => (
        <div style={{ textAlign: "right" }}>
          {formatToUSCurrency(value?.toFixed(2))}
        </div>
      ),

      width: 40,
      align: "right",
    },
    {
      title: "Pending",
      dataIndex: "pending",
      key: "total_price",
      align: "right",
      width: 40,
      render: (text, record) => {
        const pendingPrice = record?.total_price - record?.total_paid_seller;
        const formatted = pendingPrice === 0 ? 0 : pendingPrice?.toFixed(2);
        return (
          <div style={{ textAlign: "right" }}>
            {formatToUSCurrency(formatted)}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "total_price",
      key: "total_price",
      width: 50,
      render: (text, record) => {
        let pendingPrice = record?.total_price - record?.total_paid_seller;
        const status = pendingPrice !== 0 ? "Partially Paid" : "Paid";
        const badgeColor =
          status.toLowerCase() === "paid" ? "#28A745" : "#1E90FF";
        return (
          <Badge
            className="status-badge badge-radius"
            count={status}
            showZero
            color={badgeColor}
          />
        );
      },
    },
  ]?.map((col) => ({
    ...col,
    align: "left",
  }));

  const showAllCampaigns = () => {
    setHeaderText("Payouts");
    setAllCampaigns(true);
    window.scrollTo(0, 0);
    if (location.search) navigate(location?.pathname, { replace: true });
  };
  const handleRow = (record) => ({
    onClick: () => handleRowClick(record),
  });

  const handleRowClick = (record) => {
    navigate(`/seller/viewCampaigns/campaignDetails/${btoa(record?.id)}`);
  };
  const getPendingAmount = (campaign) => {
    let pendingAmount = campaign?.total_price - campaign?.total_paid_seller;
    return pendingAmount === 0 ? "0" : pendingAmount?.toFixed(2);
  };
  const getStatus = (campaign) => {
    let pendingAmount = getPendingAmount(campaign);
    const status = pendingAmount !== "$0" ? "Partially Paid" : "Paid";
    const color = status?.toLowerCase() === "paid" ? "#28A745" : "#1E90FF";
    const bgColor =
      status.toLowerCase() === "paid"
        ? "rgba(40, 167, 69, 0.20)"
        : "rgba(210,233,255,1)";
    return [status, color, bgColor];
  };
  const goToPreviousSection = () => {
    if (allCampaigns) {
      setAllCampaigns(false); // Go back to the previous section
      setHeaderText("Your Earnings & Payouts"); // Reset the header text
    } else navigate(-1);
  };
  useEffect(() => {
    dispatch(getSellerCampaignsList());
  }, []);

  useEffect(() => {
    if (payoutOverview) setAllCampaigns(false);
  }, [payoutOverview]);
  return (
    <div className="common-container">
      <>
        <div className="bread-crumb-placement">
          <BreadcrumbNav />
        </div>
        <div className="seller-payment-header">
          <Image
            className="arrow-align"
            src={BackArrow}
            preview={false}
            onClick={goToPreviousSection}
          />
          {headerText}
        </div>
        {!isMobile && <Divider className="divider" />}

        {!data && data?.length == 0 ? (
          <Row className="empty-payments-section">
            <EmptyViewCard
              header={"Payments"}
              text={
                "No payouts yet, but your earnings will start flowing soon! Keep listing your products and get ready to receive payments."
              }
            />
          </Row>
        ) : (
          <>
            {payoutOverview && !allCampaigns ? (
              <>
                <div className="overview-label">Payment Overview</div>
                {isMobile ? (
                  <>
                    <Row
                      gutter={[16, 18]}
                      style={{
                        width: "100%",
                        gap: "2%",
                        marginBottom: "2%",
                      }}
                    >
                      {paymentCardGroup &&
                        paymentCardGroup?.slice(0, 2)?.map((payment, index) => {
                          return (
                            <Col
                              key={index}
                              style={{ width: "49%", padding: 0 }}
                            >
                              <Card className="payment-card">
                                <Row>
                                  <Col
                                    span={14}
                                    className="payment-card-headers"
                                  >
                                    {payment?.title}
                                  </Col>
                                  <Col span={9} className="button-icon">
                                    {payment?.button}
                                  </Col>
                                  <Col>
                                    <span className="payout-price">
                                      {payment?.cost
                                        ? formatToUSCurrency(
                                            Number(payment?.cost ?? 0)?.toFixed(
                                              2
                                            )
                                          )
                                        : formatToUSCurrency(
                                            Number(
                                              payment?.transfer ?? 0
                                            )?.toFixed(2)
                                          )}{" "}
                                    </span>
                                    {payment?.hasProfit && (
                                      <span style={{ color: "#008342" }}>
                                        <ProfitGraphIcon /> +12 %
                                      </span>
                                    )}
                                  </Col>

                                  <Col span={24}>
                                    {payment?.title?.toLowerCase() ===
                                    "highest payout received" ? (
                                      <div className="duration">
                                        {payment?.ad}
                                      </div>
                                    ) : (
                                      <span className="duration">
                                        {payment?.numberOfDays}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          );
                        })}
                    </Row>
                    <Row gutter={[16, 18]} style={{ width: "100%", gap: "2%" }}>
                      {paymentCardGroup &&
                        paymentCardGroup
                          ?.slice(2, paymentCardGroup?.length)
                          ?.map((payment, index) => {
                            return (
                              <Col
                                key={index}
                                style={{ width: "49%", padding: 0 }}
                              >
                                <Card className="payment-card">
                                  <Row>
                                    <Col
                                      span={14}
                                      className="payment-card-headers"
                                    >
                                      {payment?.title}
                                    </Col>
                                    <Col span={9} className="button-icon">
                                      {payment?.button}
                                    </Col>
                                    <Col>
                                      <span className="payout-price">
                                        {payment?.cost
                                          ? formatToUSCurrency(
                                              Number(
                                                payment?.cost ?? 0
                                              )?.toFixed(2)
                                            )
                                          : formatToUSCurrency(
                                              Number(
                                                payment?.transfer ?? 0
                                              )?.toFixed(2)
                                            )}{" "}
                                      </span>
                                      {payment?.hasProfit && (
                                        <span style={{ color: "#008342" }}>
                                          <ProfitGraphIcon /> +12 %
                                        </span>
                                      )}
                                    </Col>

                                    <Col span={24}>
                                      {payment?.title?.toLowerCase() ===
                                      "highest payout received" ? (
                                        <div className="duration">
                                          {payment?.ad}
                                        </div>
                                      ) : (
                                        <span className="duration">
                                          {payment?.numberOfDays}
                                        </span>
                                      )}
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            );
                          })}
                    </Row>
                  </>
                ) : (
                  <>
                    {" "}
                    <Row gutter={[16, 18]} style={{ width: "100%", gap: "1%" }}>
                      {paymentCardGroup &&
                        paymentCardGroup?.map((payment, index) => {
                          return (
                            <Col
                              key={index}
                              style={{ width: "24%", padding: 0 }}
                            >
                              <Card className="payment-card">
                                <Row>
                                  <Col
                                    span={14}
                                    className="payment-card-headers"
                                  >
                                    {payment?.title}
                                  </Col>
                                  <Col span={9} className="button-icon">
                                    {payment?.button}
                                  </Col>
                                  <Col>
                                    <span className="payout-price">
                                      {payment?.cost
                                        ? formatToUSCurrency(
                                            Number(payment?.cost ?? 0)?.toFixed(
                                              2
                                            )
                                          )
                                        : formatToUSCurrency(
                                            Number(
                                              payment?.transfer ?? 0
                                            )?.toFixed(2)
                                          )}{" "}
                                    </span>
                                    {payment?.hasProfit && (
                                      <span style={{ color: "#008342" }}>
                                        <ProfitGraphIcon /> +12 %
                                      </span>
                                    )}
                                  </Col>

                                  <Col span={24}>
                                    {payment?.title?.toLowerCase() ===
                                    "highest payout received" ? (
                                      <div className="duration">
                                        {payment?.ad}
                                      </div>
                                    ) : (
                                      <span className="duration">
                                        {payment?.numberOfDays}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          );
                        })}
                    </Row>
                  </>
                )}

                <div className="campaigns-container">
                  <Row className="recent-campaigns-section">
                    <Col className="payout-label">Recent Payouts</Col>
                    {data?.length > 0 && (
                      <Col className="view-all" onClick={showAllCampaigns}>
                        View all
                      </Col>
                    )}
                  </Row>
                  {isMobile ? (
                    <div>
                      {data && data?.length > 0 ? (
                        <>
                          {data &&
                            data?.slice(0, 7)?.map((campaign) => {
                              return (
                                <Card className="mobile-campaign-cards">
                                  <div className="status-section">
                                    <Badge
                                      className="status-badge"
                                      style={{
                                        background: getStatus(campaign)[2],
                                        color: getStatus(campaign)[1],
                                      }}
                                      count={getStatus(campaign)[0]}
                                    />
                                  </div>
                                  <Row style={{ marginBottom: "0.5rem" }}>
                                    <Col span={14}>
                                      <div className="campaign-labels">
                                        Campaign ID
                                      </div>
                                      <div className="campaign-values">
                                        {campaign?.cid}
                                      </div>
                                    </Col>
                                    <Col span={10}>
                                      <div className="campaign-labels">
                                        Amount ID
                                      </div>
                                      <div className="campaign-values">
                                        {formatToUSCurrency(
                                          campaign?.total_price.toFixed(2)
                                        )}
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row gutter={5} style={{ gap: "0.5rem" }}>
                                    <Col span={14}>
                                      <div className="campaign-labels">
                                        Campaign
                                      </div>
                                      <div className="campaign-values">
                                        {campaign?.name}
                                      </div>
                                    </Col>
                                    <Col span={10}>
                                      <div className="campaign-labels">
                                        Paid
                                      </div>
                                      <div className="campaign-values">
                                        {formatToUSCurrency(
                                          campaign?.total_paid_seller?.toFixed(
                                            2
                                          )
                                        )}
                                      </div>
                                    </Col>
                                    <Col>
                                      <div className="campaign-labels">
                                        Pending Amount
                                      </div>
                                      <div className="campaign-values">
                                        {formatToUSCurrency(
                                          getPendingAmount(campaign)
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </Card>
                              );
                            })}
                        </>
                      ) : (
                        <EmptyViewCard
                          header={"Payments"}
                          text={"Looks like there are no recent payments..."}
                        />
                      )}
                    </div>
                  ) : (
                    <Table
                      sticky
                      className="payments-table partial-payments-table"
                      columns={columns}
                      dataSource={data && data?.slice(0, 7)}
                      pagination={false}
                      tableLayout="fixed"
                    />
                  )}
                </div>
              </>
            ) : isMobile ? (
              <>
                {data && data?.length > 0 ? (
                  data &&
                  data?.map((campaign) => {
                    return (
                      <Card className="mobile-campaign-cards">
                        <div className="status-section">
                          <Badge
                            className="status-badge"
                            style={{
                              background: getStatus(campaign)[2],
                              color: getStatus(campaign)[1],
                            }}
                            count={getStatus(campaign)[0]}
                          />
                        </div>
                        <Row>
                          <Col span={14}>
                            <div className="campaign-labels">Campaign ID</div>
                            <div className="campaign-values">
                              {campaign?.cid}
                            </div>
                          </Col>
                          <Col span={10}>
                            <div className="campaign-labels">Amount ID</div>
                            <div className="campaign-values">
                              {formatToUSCurrency(
                                campaign?.total_price?.toFixed(2)
                              )}
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={5}>
                          <Col span={14}>
                            <div className="campaign-labels">Campaign</div>
                            <div className="campaign-values">
                              {campaign?.name}
                            </div>
                          </Col>
                          <Col span={10}>
                            <div className="campaign-labels">Paid</div>
                            <div className="campaign-values">
                              {formatToUSCurrency(
                                campaign?.total_paid_seller?.toFixed(2)
                              )}
                            </div>
                          </Col>
                          <Col>
                            <div className="campaign-labels">
                              Pending Amount
                            </div>
                            <div className="campaign-values">
                              {formatToUSCurrency(getPendingAmount(campaign))}
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    );
                  })
                ) : (
                  <EmptyViewCard
                    header={"Payments"}
                    text={"Looks like there are no recent payments..."}
                  />
                )}
              </>
            ) : (
              <span className="all-campaigns-desktop">
                <Table
                  className="payments-table all-payments-table"
                  columns={columns}
                  tableLayout="fixed"
                  dataSource={data}
                  pagination={false}
                  onRow={handleRow}
                />
              </span>
            )}
          </>
        )}
      </>
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};

export default Payments;
